export default __webpack_public_path__ + "static/media/logoWhite.83180f58.svg";